import localforage from 'localforage';

// Configura localforage
localforage.config({
  name: 'repairManager',
  storeName: 'devices'
});

const CACHE_EXPIRY = 24 * 60 * 60 * 1000; // 24 ore in millisecondi

export const cacheService = {
  async set(key, data) {
    try {
      await localforage.setItem(key, {
        data,
        timestamp: Date.now()
      });
    } catch (error) {
      console.error('Cache write error:', error);
    }
  },

  async get(key) {
    try {
      const cached = await localforage.getItem(key);
      if (!cached) return null;

      // Verifica se la cache è scaduta
      if (Date.now() - cached.timestamp > CACHE_EXPIRY) {
        await localforage.removeItem(key);
        return null;
      }

      return cached.data;
    } catch (error) {
      console.error('Cache read error:', error);
      return null;
    }
  },

  async remove(key) {
    try {
      await localforage.removeItem(key);
    } catch (error) {
      console.error('Cache remove error:', error);
    }
  }
}; 